<template>
  <li :class="isSubmenuList ? 'mb-0 border-l border-gray-300' : 'mb-1'">
    <component
      v-slot="vSlot"
      :is="componentIs"
      :to="itemTo"
      :href="itemHref"
      :target="itemTarget"
      @click="onItemClick"
    >
      <div
        class="flex items-center gap-2 cursor-pointer pl-3 pr-2 clear-left menu-list hover:text-black"
        :class="(vSlot?.isExactActive || isChildActive) ? styleActive : styleInactive"
      >
        <icon
          v-if="item.icon"
          :path="item.icon"
          class="pb-1"
          :class="
            hasDropdown && isDropdownActive && isChildActive ? 'text-white'
            : hasDropdown && isDropdownActive && !isChildActive ? 'text-black'
            : ''
          "
        />

        <span
          class="flex-1"
          :class="
            hasDropdown && isDropdownActive && isChildActive ? 'text-white'
            : hasDropdown && isDropdownActive && !isChildActive ? 'text-black'
            : ''
          "
          v-html="t(item.label)"
        />

        <icon
          v-if="hasDropdown"
          :path="mdiChevronRight"
          class="pb-1 transition-transform duration-300 transform origin-center"
          :class=" {
            'text-white' : hasDropdown && isDropdownActive && isChildActive,
            'text-black' : hasDropdown && isDropdownActive && !isChildActive,
            'rotate-90' : isDropdownActive
          }"
        />
      </div>
    </component>

    <transition name="slide">
      <div
        class="menu-child pl-4 border-l border-gray-400 dark:border-gray-600"
        v-show="isDropdownActive"
      >
        <aside-menu-list
          v-for="(menuGroup, idx) in item.menu"
          :key="idx"
          is-submenu-list
          :menu="menuGroup"
          @menu-click="onChildClick"
        />
      </div>
    </transition>
  </li>
</template>

<script>
  import { defineAsyncComponent, ref, computed, watchEffect } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useRoute } from 'vue-router'
  import { mdiChevronRight } from '@mdi/js'

  export default {
    name: 'AsideMenuItem',

    components: {
      AsideMenuList: defineAsyncComponent(() => import('@/components/AsideMenuList')),
      Icon: defineAsyncComponent(() => import('@/components/Icon'))
    },

    props: {
      item: { type: Object, default: () => ({}) },
      isSubmenuList: { type: Boolean, default: false }
    },

    setup (props, { emit }) {
      const { t } = useI18n()
      const route = useRoute()

      const componentIs = computed(() => (props.item.to ? 'router-link' : 'a'))
      const itemTo = computed(() => props.item.to || null)
      const itemHref = computed(() => props.item.href || null)
      const itemTarget = computed(() =>
        componentIs.value === 'a' && props.item.target ? props.item.target : null
      )

      const hasDropdown = computed(
        () => Array.isArray(props.item.menu) && props.item.menu.length > 0
      )

      // cek child aktif (rekursif sederhana)
      const isChildActive = computed(() => {
        if (!hasDropdown.value) return false
        return props.item.menu.some(child => {
          if (child.menu && child.menu.length) {
            // nested child
            return child.menu.some(grand => route.path.startsWith(grand.to || ''))
          }
          return child.to && route.path.startsWith(child.to)
        })
      })

      const isDropdownActive = ref(false)

      // buka dropdown otomatis jika child aktif
      watchEffect(() => {
        if (isChildActive.value) {
          isDropdownActive.value = true
        }
      })

      const onItemClick = (event) => {
        emit('menu-click', event, props.item)
        if (hasDropdown.value) {
          isDropdownActive.value = !isDropdownActive.value
          event.preventDefault()
        }
      }

      const onChildClick = (event, childItem) => {
        emit('menu-click', event, childItem)
      }

      const styleActive = 'sidebar-active'
      const styleInactive = 'text-gray-400 dark:text-gray-500 py-2'

      return {
        t,
        mdiChevronRight,
        componentIs,
        itemTo,
        itemHref,
        itemTarget,
        hasDropdown,
        isDropdownActive,
        isChildActive,
        onItemClick,
        onChildClick,
        styleActive,
        styleInactive
      }
    }
  }
</script>

<style scoped>
  .slide-enter-active,
  .slide-leave-active {
    transition: all 0.25s ease;
  }
  .slide-enter-from,
  .slide-leave-to {
    max-height: 0;
    opacity: 0;
  }
</style>
